import React, { Component } from 'react';
import { connect } from 'react-redux';
import Actions from '~/Actions';
import { withRouter } from 'react-router-dom';
import { Button, InputBase, Tooltip } from '@material-ui/core';
import PageTitle from '~/components/PageTitle';
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import '~/font.css';
import { EAA_Item, EAA_ItemContainer, EAA_Input, EAA_ErrorText, EAA_Row, EAA_TitleText, EAA_Date, EAA_Btn } from '~/components/EditAndAddItem';
import { rightColor, leftColor } from '~/components/EditAndAddItem/common';
import EditRes from '~/components/Dialog/EditRes';

class Page_NotifyMail extends Component {
  state={ mode: 'edit', mainText: '', editorState: EditorState.createEmpty(), canSend: true }

  componentDidMount () {
    this.white = true;
    this.reflesh();
  }

  componentDidUpdate (preProps) {
    const { preMsgUser = {}, lMsgUser: preLMsgUser = {} } = preProps;
    const { msgUser = {}, lMsgUser = {} } = this.props;
    if (Object.keys(preMsgUser).length === 0 && Object.keys(msgUser).length > 0 && msgUser.content && this.white) {
      this.white = false;
      this.refleshState(msgUser);
      // if (msgUser.version && msgUser.version > 0) this.props.getLMsgUser(msgUser.version - 1);
    }
    if (Object.keys(preLMsgUser).length === 0 && Object.keys(lMsgUser).length > 0) {
      this.refleshState(lMsgUser);
    }
  }

  componentWillUnmount () {
    this.props.clearKey('MsgUser');
  }

  reflesh=() => this.props.getMsgUser();

  refleshState=(object = {}) => {
    const { clearKey } = this.props;
    let text = object.content || '<p></p>';
    let mainText = object.title || '';
    const { data = {} } = object;
    const { message_tag_list = [] } = data;
    for (let i = 0; i < message_tag_list.length; i++) {
      while (text.match(message_tag_list[i].value)) {
        // text = text.replace(message_tag_list[i].value, `<span style="color: rgb(26,99,172);">${message_tag_list[i].name}</span>`);
        text = text.replace(message_tag_list[i].value, message_tag_list[i].name);
      }
      while (mainText.match(message_tag_list[i].value)) {
        mainText = mainText.replace(message_tag_list[i].value, message_tag_list[i].name);
      }
    }
    // const contentBlock = htmlToDraft(msgUser.content);
    const contentBlock = htmlToDraft(text);
    const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
    const editorState = EditorState.createWithContent(contentState);
    this.setState({ editorState, mainText }, () => { clearKey('LMsgUser'); });
  }

  onEditorStateChange = editorState => {
    this.setState({ editorState });
  };

  copy=async text => {
    await navigator.clipboard.writeText(text);
  }

  send=() => {
    this.setState({ canSend: false });
    const { mainText, editorState } = this.state;
    const { msgUser = {}, postUpdateMail } = this.props;
    const { data = {} } = msgUser;
    const { message_tag_list = [] } = data;
    let content = draftToHtml(convertToRaw(editorState.getCurrentContent()));
    let title = mainText;

    for (let i = 0; i < message_tag_list.length; i++) {
      while (content.match(message_tag_list[i].name)) {
        content = content.replace(message_tag_list[i].name, message_tag_list[i].value);
      }
      while (title.match(message_tag_list[i].name)) {
        title = title.replace(message_tag_list[i].name, message_tag_list[i].value);
      }
    }
    const body = {
      code: 'user_check',
      content,
      title,
    };
    postUpdateMail(body);
  }

  _view=() => this.setState({ mode: 'view' })
  _goback=() => this.setState({ mode: 'edit' })

  renderMainView=() => {
    const { mainText, mode } = this.state;
    const disabled = mode !== 'edit';
    return (
      <div style={{ width: '100%', display: 'flex', marginTop: 35 }}>
        <div style={{ width: 166, display: 'flex', paddingTop: 15 }}>
          <div style={{ marginLeft: 69, color: '#FF0000', fontSize: 16 }}>*</div>
          <div style={{ fontSize: 16 }}>主旨</div>
        </div>
        <div style={{ flex: 1, marginRight: 59 }}>
          <InputBase
            disabled={disabled}
            style={{
              backgroundColor: disabled ? '#ededed' : 'white',
              width: '100%',
              height: 133,
              fontSize: 16,
              letterSpacing: '0.15px',
              borderRadius: 14,
              paddingLeft: 12,
              alignItems: 'start',
              paddingTop: 10,
              paddingBottom: 10,
              boxShadow: '0px 6px 10px -2px #979797',
              border: '1px solid rgba(0,0,0,0.32)',
            }}
            placeholder={'例如: 使用者姓名，方便查閱'}
            inputProps={{ height: 44 }}
            onChange={e => this.setState({ mainText: e.target.value })}
            rowsMax={6}
            multiline
            value={mainText}
          />
        </div>
      </div>
    );
  }

  renderEMailView=() => {
    const { editorState, mode } = this.state;
    const disabled = mode !== 'edit';
    return (
      <div style={{ width: '100%', display: 'flex', marginTop: 18 }}>
        <div style={{ width: 166, display: 'flex', paddingTop: 15 }}>
          <div style={{ marginLeft: 69, color: '#FF0000', fontSize: 16 }}>*</div>
          <div style={{ fontSize: 16 }}>內容</div>
        </div>
        <div style={{ flex: 1, marginRight: 59 }}>
          <Editor
            readOnly={disabled}
            editorState={editorState}
            toolbar={{
            // options: ['inline', 'blockType', 'fontSize', 'fontFamily', 'list', 'textAlign', 'colorPicker', 'link', 'embedded', 'emoji', 'image', 'remove', 'history'],
              options: ['history', 'fontFamily', 'blockType', 'colorPicker', 'fontSize', 'inline', 'textAlign', 'list', 'link', 'image', 'remove'],
              inline: {
              // options: ['bold', 'italic', 'underline', 'strikethrough', 'monospace', 'superscript', 'subscript'],
                options: ['bold', 'italic', 'underline', 'strikethrough'],
              },
              textAlign: { inDropdown: true },
              list: { inDropdown: true },
              link: { inDropdown: true },
              fontFamily: { options: ['-moz-initial', '標楷體', 'serif', 'cursive', 'fantasy', 'monospace', 'garamond', 'georgia', 'tahoma', 'verdana'] },
            }}
            toolbarStyle={{ borderTopRightRadius: 14, borderTopLeftRadius: 14 }}
            wrapperStyle={{ backgroundColor: disabled ? '#ededed' : 'white', borderRadius: 14, width: '100%', paddingBottom: 14, border: '1px solid #979797', boxShadow: '0px 6px 10px -2px rgba(67, 67, 75, 0.2)' }}
            editorStyle={{ fontFamily: '-moz-initial', backgroundColor: disabled ? '#ededed' : 'white', width: '100%', borderBottomRightRadius: 14, borderBottomLeftRadius: 14, paddingLeft: 12, height: 221 }}
            onEditorStateChange={this.onEditorStateChange}
          />
        </div>
      </div>
    );
  }

  renderCopyLink=() => (
    <div style={{ marginTop: 15, marginLeft: 176, marginRight: 59 }}>
      <div
        className="Noto_Sans_SC"
        style={{ display: 'flex', fontSize: 16, fontWeight: 500 }}
      >
        <div style={{ color: '#FF0000' }}>★</div>
        本通知信參數由系統自動帶入，參數內容說明如下：
        <div style={{ fontWeight: 200 }}>(點擊連結複製到剪貼板)</div>
      </div>
      <div style={{ display: 'flex', fontSize: 16 }}>
        {'1. {'}
        <Tooltip title='{user_check.name}' placement='left'>
          <div style={{ color: '#1A63AC', marginLeft: 5, marginRight: 5, cursor: 'pointer' }} onClick={() => this.copy('{清查名稱}')}>{'清查名稱'}</div>
        </Tooltip>
        {' } ：'}
        帳號清查管理\清查作業\清查作業新增之「清查名稱」欄位資料。
      </div>
      <div style={{ display: 'flex', fontSize: 16 }}>
        {'2. {'}
        <Tooltip title='{user.user_name}' placement='left'>
          <div style={{ color: '#1A63AC', marginLeft: 5, marginRight: 5, cursor: 'pointer' }} onClick={() => this.copy('{使用者名稱}')}>{'使用者名稱'}</div>
        </Tooltip>
        {' } ：'}
        帳號清查管理\清查作業\清查作業新增之「清查名稱」欄位資料。
      </div>
      <div style={{ display: 'flex', fontSize: 16 }}>
        {'3. {'}
        <Tooltip title='{user_check.end_date}' placement='left'>
          <div style={{ color: '#1A63AC', marginLeft: 5, marginRight: 5, cursor: 'pointer' }} onClick={() => this.copy('{清查作業結束時間}')}>{'清查作業結束時間'}</div>
        </Tooltip>
        {' } ：'}
        帳號清查管理\清查作業\清查作業新增之「清查日期（迄）」欄位資料。
      </div>
    </div>
  )

  renderBtn=() => {
    const { mode, canSend } = this.state;
    const { msgUser = {}, getLMsgUser } = this.props;
    return (
      <div className='Noto_Sans_SC' style={{ marginTop: 38, width: '100%', display: 'flex', justifyContent: 'center' }}>
        {mode === 'edit' && <EAA_Btn text='載入前次版本' width={136} backgroundColor={leftColor} onClick={() => { if (msgUser.version && msgUser.version > 0) getLMsgUser(msgUser.version - 1); }} />}
        {mode === 'edit' && <EAA_Btn text='使用此範本並預覽' width={172} backgroundColor={rightColor} onClick={this._view} style={{ marginLeft: 21 }} />}
        {mode === 'view' && (
          <EAA_Btn text='回上一頁編輯' width={152} backgroundColor={leftColor} onClick={this._goback}>
            <svg style={{ marginRight: 5 }} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M14.7083 5.29232C13.5 4.08398 11.8417 3.33398 10 3.33398C6.31667 3.33398 3.34167 6.31732 3.34167 10.0007C3.34167 13.684 6.31667 16.6673 10 16.6673C13.1083 16.6673 15.7 14.5423 16.4417 11.6673H14.7083C14.025 13.609 12.175 15.0007 10 15.0007C7.24167 15.0007 5.00001 12.759 5.00001 10.0007C5.00001 7.24232 7.24167 5.00065 10 5.00065C11.3833 5.00065 12.6167 5.57565 13.5167 6.48398L10.8333 9.16732H16.6667V3.33398L14.7083 5.29232Z" fill="white" />
            </svg>
          </EAA_Btn>
        )}
        {mode === 'view' && <EAA_Btn text='儲存' disabled={!canSend} width={172} backgroundColor={canSend ? rightColor : 'gray'} onClick={this.send} style={{ marginLeft: 21 }} />}
      </div>
    );
  }

  render () {
    return (
      <div style={{
        position: 'absolute',
        left: 13,
        right: 0,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
        overflow: 'auto',
      }}
      >
        <PageTitle text={'通知信維護'} />
        {this.renderMainView()}
        {this.renderEMailView()}
        {this.renderCopyLink()}
        {this.renderBtn()}
        <EditRes sucFunc={() => { this.reflesh(); this.setState({ canSend: true, mode: 'edit' }); }} failFunc={() => this.setState({ canSend: true })} resKey='PostUpdateMail' />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  msgUser: state.data.MsgUser,
  lMsgUser: state.data.LMsgUser,
});
const mapDispatchToProps = dispatch => ({
  getMsgUser: () => Actions.getMsgUser(dispatch),
  getLMsgUser: version => Actions.getLMsgUser(dispatch, { version }),
  clearKey: key => Actions.clearKey(dispatch, { key }),
  postUpdateMail: body => Actions.postUpdateMail(dispatch, { body }),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Page_NotifyMail));
